import { CollectionResponse } from "@authory-packages/core";
import { DEFAULT_COLLECTION_LABEL } from "../types/collection";

/**
 * A collection is considered "populated" once it holds at least one content
 * item or has at least one rule set.
 */
export const collectionHasContentOrRules = (collection: Pick<CollectionResponse, "publicationCount" | "ruleCount">) =>
    !!collection.publicationCount || !!collection.ruleCount;

/**
 * The "This collection has auto-updating..." banner is only relevant for
 * non-default collections that are already populated.
 */
export const showCollectionAutoUpdateBanner = (collection: Pick<CollectionResponse, "default" | "publicationCount" | "ruleCount">) =>
    !collection.default && collectionHasContentOrRules(collection);

/**
 * The "This collection does not have a name yet" banner only shows in the
 * profile area for populated collections that still carry the default name.
 */
export const showCollectionNoNameBanner = (collection: Pick<CollectionResponse, "label" | "publicationCount" | "ruleCount">) =>
    collectionHasContentOrRules(collection) && collection.label === DEFAULT_COLLECTION_LABEL;
